<template>
  <Modal :modal-active="isOpen" max-width="max-w-5xl" @close="handleCancel">
    <template #header v-if="title">
      <h2 class="text-xl font-bold text-primary40">{{ title }}</h2>
    </template>
    <div class="px-5 py-4">
      <DsAttendancePolicy
        :initial-data="props.initialData"
        :available-shifts="props.availableShifts"
        :schedule-end-date="props.scheduleEndDate"
        :can-edit-registration-section="props.canEditRegistrationSection"
        :open-activity-records="props.openActivityRecords"
        :schedule-id="props.scheduleId"
        :inherited-check-flags="props.inheritedCheckFlags"
        :current-check-requirement="props.currentCheckRequirement"
        @save="handleSave"
        @cancel="handleCancel"
        fullWidthModal
      />
    </div>
  </Modal>
</template>

<script setup lang="ts">
import Modal from '@/components/designSystem/modals/Modal.vue'
import DsAttendancePolicy from '@/components/ManageScale/Schedule/DsAttendancePolicy.vue'

import type { DSAttendancePolicyData } from '@/types/ds-attendance.types'
import type { CurrentCheckRequirement, ScheduleCheckFlags } from '@/utils/registrationCheck'

const props = withDefaults(
  defineProps<{
    isOpen: boolean
    initialData?: DSAttendancePolicyData | null
    title?: string
    availableShifts?: { title: string; value: number }[]
    scheduleEndDate?: string | null
    /** Cadeado da Q31 (F2/M4) — repassado ao formulário; `undefined` deixa a tela consultar. */
    canEditRegistrationSection?: boolean
    /** Registros de atividade vivos na escala, para o aviso ① de M4. */
    openActivityRecords?: number | null
    /** Escala da política — o aviso ⑥ de M5 (impacto do gate) precisa dela. */
    scheduleId?: number | null
    /** M7 (§3) — flags legadas da escala; herança inicial dos interruptores de check. */
    inheritedCheckFlags?: ScheduleCheckFlags | null
    /** M7 (§4) — o que a escala exige hoje; linha de base do aviso de desligamento. */
    currentCheckRequirement?: CurrentCheckRequirement | null
  }>(),
  {
    // Sem o default explícito, o boolean casting do Vue transformaria a prop ausente
    // em `false` e o modal mandaria "não pode editar" para o formulário.
    canEditRegistrationSection: undefined
  }
)

const emit = defineEmits<{
  (e: 'close'): void
  (e: 'save', data: DSAttendancePolicyData): void
}>()

const handleSave = (data: DSAttendancePolicyData) => {
  emit('save', data)
}

const handleCancel = () => {
  emit('close')
}
</script>
